import classnames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";
import { MdCheck, MdContentCopy } from "react-icons/md";

const COPIED_FEEDBACK_MS = 1500;

const CopySuffix = ({ getValue, shifted = false }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (event) => {
    event.preventDefault();
    const value = getValue();
    if (!value || !navigator.clipboard) return;
    try {
      await navigator.clipboard.writeText(value);
    } catch (error) {
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      className={classnames("input__copy", { "input__copy--shifted": shifted })}
      onMouseDown={copyToClipboard}
    >
      {copied ? <MdCheck size={16} /> : <MdContentCopy size={16} />}
    </span>
  );
};

CopySuffix.propTypes = {
  getValue: PropTypes.func.isRequired,
  shifted: PropTypes.bool,
};

export default CopySuffix;
